import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const DataLayerTableColumns: ITableColumn[] = [
  {
    labelPath: 'dataLensPage.tableColumns.dataItem',
    propertyKey: 'dataItemWithIcon',
    colType: TableColumnTypeEnum.TextWithIcon,
    iconSrc: 'dataItemWithIconIcon',
    width: 350,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'resourceName',
    withTruncation: true,
  },
  {
    labelPath: 'dataLensPage.tableColumns.accessCount',
    propertyKey: 'accessCount',
    colType: TableColumnTypeEnum.Number,
    width: 130,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'accessCount',
  },
  {
    labelPath: 'dataLensPage.tableColumns.lastAccessed',
    propertyKey: 'lastAccessed',
    colType: TableColumnTypeEnum.Date,
    width: 180,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'lastAccessed',
  },
  {
    labelPath: 'dataLensPage.tableColumns.findings',
    propertyKey: 'findingsBySeverity',
    colType: TableColumnTypeEnum.Severities,
    width: 130,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'dataLensPage.tableColumns.sensitivity',
    propertyKey: 'sensitivityLabel',
    colType: TableColumnTypeEnum.SingleTag,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
